/**
 * FlyFreely API
 *
 * Contact: support@flyfreely.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MissionObjectiveDto } from './missionObjectiveDto';
import { MissionOperationTypeDto } from './missionOperationTypeDto';
import { ProjectDto } from './projectDto';
import { SimpleMissionWorkflowDto } from './simpleMissionWorkflowDto';
import { SimplePersonDto } from './simplePersonDto';
import { SimpleWorkgroupDto } from './simpleWorkgroupDto';

export interface AutomaticMissionConfigurationDto {
    collectionSourceId: number;
    type: AutomaticMissionConfigurationDto.Type;
    useCollectionSourceOwner: boolean;
    remotePilot?: SimplePersonDto;
    operationType?: MissionOperationTypeDto;
    missionWorkflow?: SimpleMissionWorkflowDto;
    workgroup?: SimpleWorkgroupDto;
    project?: ProjectDto;
    missionObjective?: MissionObjectiveDto;
    requireRpa: boolean;
    missionPerRpa: boolean;
    maxDistance: number;
    maxTimeDifference: number;
    createFlightOnAssignment: boolean;
}
export namespace AutomaticMissionConfigurationDto {
    export type Type =
        | 'ORGANISATION_DEFAULT'
        | 'MISSION_SUGGESTION'
        | 'MISSION_ASSIGNMENT'
        | 'MISSION_CREATION'
        | 'DISABLED';
    export const Type = {
        ORGANISATION_DEFAULT: 'ORGANISATION_DEFAULT' as Type,
        MISSION_SUGGESTION: 'MISSION_SUGGESTION' as Type,
        MISSION_ASSIGNMENT: 'MISSION_ASSIGNMENT' as Type,
        MISSION_CREATION: 'MISSION_CREATION' as Type,
        DISABLED: 'DISABLED' as Type
    };
}
